// A product's picture, or something deliberate when there isn't one.
//
// Every device card rendered <img src={maybeUndefined}>, so a product with no
// asset showed the browser's broken-image icon with the product number as alt
// text. On a grid of units that reads as broken data — which is exactly how it
// was reported — when the truth is only that nobody has photographed that
// product yet.

import React from 'react';
import { getProductImage } from '../productImages';
import { colors } from '../theme';

export default function ProductThumb({ productNumber, style, alt }) {
  const src = getProductImage(productNumber);
  const label = alt || productNumber || 'Product';

  if (src) {
    return <img src={src} alt={label} style={style} />;
  }

  return (
    <div
      role="img"
      aria-label={`${label} — no product image`}
      title={`No product image for ${label}`}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        minHeight: 48,
        borderRadius: 10,
        border: `1px dashed ${colors.panelBorder}`,
        background: 'rgba(255,255,255,0.03)',
        ...style,
      }}
    >
      {/* A monitor outline: enough to read as "a product", quiet enough not to
          be mistaken for the product itself. */}
      <svg width="38%" height="38%" viewBox="0 0 24 18" fill="none" aria-hidden="true"
           style={{ opacity: 0.35, maxWidth: 44, maxHeight: 33 }}>
        <rect x="1" y="1" width="22" height="14" rx="1.6"
              stroke={colors.textMuted} strokeWidth="1.4" />
        <path d="M9 17h6" stroke={colors.textMuted} strokeWidth="1.4" strokeLinecap="round" />
      </svg>
    </div>
  );
}
